<template>
  <section class="pa-2">
    <v-card class="p-1">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Suspicious Customer</div>
        <div>
          <bread-crumb :bread-crumbs="['Suspicious Customer']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        dense
        :search="search"
        class="mt-2"
        :items="SuspiciosList"
      >
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-btn
              x-small
              color="success"
              title="Release"
              class="mr-2"
              @click="openDialog(item)"
            >
              <v-icon small class="me-1"> mdi-check-circle </v-icon>Release
            </v-btn>

            <v-btn x-small @click="opensanctions(item)" color="primary">
              Matched
            </v-btn>
          </div>
        </template>
        <template v-slot:top>
          <!-- <v-divider class="p-0 m-0 primary--text"></v-divider> -->
          <v-row class="ms-1 me-1 mt-5">
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="me-2"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-10"
              dense
              clearable
            ></v-text-field>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog persistent v-model="showSantionsDialog" width="1200">
      <v-card class="pa-0">
        <v-toolbar color="seconadry" dark flat dense>
          <span
            >Sanction Matched List:
            <Strong>{{
              highlightedWord.join(" ")
            }}</Strong></span
          >
          <v-spacer></v-spacer>
          <v-btn depressed icon @click="closeSantionList()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-4">
          <sanctionMatched
            :matchedsanctionsdata="matchedsanctionsdata"
            :highlightWord="highlightedWord"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Release dialog -->
    <v-dialog persistent v-model="showDialog" width="500">
      <v-card>
        <v-form ref="Addform" v-model="valid">
          <v-toolbar color="seconadry" dark flat dense>
            <span>Compliance</span>
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-row class="mt-5">
              <v-col cols="12" md="12">
                <label class="my-0 rounded required">
                  Your are about release compliance transaction.Please enter
                  Notes/Remarks
                </label>
                <v-textarea
                  class="rounded"
                  v-model="remarks"
                  dense
                  outlined
                  :rules="FieldRequired('This Field')"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mb-0"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              small
              class="text-capitalize"
              @click="updateStatus('Approved')"
            >
              <v-icon small>mdi-check-circle</v-icon> Approve
            </v-btn>
            <v-btn
              depressed
              color="error"
              small
              class="text-capitalize"
              @click="updateStatus('Rejected')"
            >
              <v-icon small>mdi-close-circle</v-icon> Reject
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <OverlayPageVue :showOverlay="loader" />
  </section>
</template>
<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import { FieldRequired } from "@/utils/validation.js";
import userService from "@/services/UserService/userService.js";
import sanctionMatched from "./sanctionMatched.vue";
import commonService from "@/services/CommonService/commonService.js";
import alerts from "@/mixins/alerts";
export default {
  name: "Suspicious Customer",
  mixins: [alerts],
  data: () => {
    return {
      FieldRequired,
      loader: false,
      highlightedWord: [],
      id: null,
      valid: true,
      search: "",
      remarks: "",
      showDialog: false,
      showSantionsDialog: false,
      matchedsanctionsdata: null,
      selectedCust_id: null,
      headers: [
        {
          text: "Customer Id",
          value: "customer_id",
          sortable: false,
        },
        {
          text: "User Id",
          value: "user_id",
          sortable: false,
        },
        {
          text: "Customer Name",
          value: "full_name",
          sortable: false,
        },
        { text: "Customer Type", value: "customer_type", sortable: false },
        { text: "Nationality", value: "nationality", sortable: false },
        { text: "Address", value: "address", sortable: false },
        { text: "Date of Birth", value: "dob", sortable: false },
        { text: "Mobile Number", value: "mobile_number", sortable: false },
        { text: "Id Type", value: "id_type", sortable: false },
        { text: "Id Number", value: "id_number", sortable: false },
        { text: "Occupation", value: "occupation", sortable: false },
        {
          text: "Source of Income",
          value: "source_of_fund",
          sortable: false,
        },
        { text: "Actions", value: "action", sortable: false },
        // { text: "Deposit Type", value: "account_type", sortable: false  },
      ],
      SuspiciosList: [],
    };
  },
  components: {
    BreadCrumb,
    OverlayPageVue,
    sanctionMatched,
  },
  mounted() {
    this.getcomplianceHold();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.SuspiciosList) {
        this.exportToExcel(this.headers, this.SuspiciosList, "Suspicios List");
      }
    },
    openDialog(item) {
      this.selectedCust_id = item.customer_id;
      this.showDialog = true;
    },

    closeDialog() {
      this.showDialog = false;
      this.selectedCust_id = null;
      this.remarks = null;
      this.$refs.Addform.resetValidation();
    },
    closeSantionList() {
      this.showSantionsDialog = false;
    },

    async updateStatus(status) {
      this.loader = true;
      if (this.$refs.Addform.validate()) {
        try {
          const response = await userService.updateSanctionCust({
            id: this.selectedCust_id,
            remarks: this.remarks,
            status: status,
          });
          if (response.status === 200) {
            this.matchedsanctionsdata = response.data.data;
            this.closeDialog();
            this.getcomplianceHold();
            this.stoploader();
          } else {
            this.showAlertError(`Failed to fetch: ${response.data.message}`);
          }
          console.log("countryOptions", this.matchedsanctionsdata);
        } catch (e) {
          console.error(e);
          this.stoploader();
          this.matchedsanctionsdata = [];
        }
      }
    },
    async opensanctions(item) {
      this.loader = true;

      try {
        const response = await commonService.getcompliancematchedsanctions(
          item.customer_id,
        );
        if (response.status === 200) {
          this.matchedsanctionsdata = response.data.data;
          console.log("item.full_name", item.full_name, "item.full_name");
          this.highlightedWord = item.full_name.split(" ");
          console.log("this.highlightedWord", this.highlightedWord);
          this.showSantionsDialog = true;
          this.stoploader();
        } else {
          this.showAlertError(`Failed to fetch: ${response.data.message}`);
        }
        console.log("countryOptions", this.matchedsanctionsdata);
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.matchedsanctionsdata = [];
      }
    },

    async getcomplianceHold() {
      this.loader = true;
      try {
        const response = await userService.getAllsanctionCustomer();
        if (response.status === 200) {
          this.SuspiciosList = response.data.data;
          this.stoploader();
        }
        console.log("countryOptions", this.SuspiciosList);
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.showAlertError("Something went wrong please try again later.");
        this.SuspiciosList = [];
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
